var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"SCHOOL OPERATIONS","title":"Attendance Management","description":"Record student attendance and monitor arrival and departure activity.","count-label":"attendance tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }